<template>
    <el-container class="adminLayout">
        <el-header class="adminLayoutHeader hidden-sm-and-down">
            <AppHeader />
        </el-header>
        <el-container class="adminLayoutMain" :class="containerClass">
            <aside class="adminLayoutMainLeft-Menu hidden-sm-and-down">
                <div class="adminLayout-menu-body"><Menu /></div>
                <div class="adminLayout-menu-foot" title="折叠/展开菜单">
                    <li class="adminLayout-menu-foot-item">
                        <el-icon @click="toggleMenuExpandState" v-show="menuExpandState"><expand /></el-icon>
                        <el-icon @click="toggleMenuExpandState" v-show="!menuExpandState" class="menu-foot-flod"><fold /></el-icon>
                    </li> 
                </div>
            </aside>
            <el-main class="appBody">
                <router-view :key="$route.fullPath">
                </router-view>
            </el-main>   
        </el-container>
    </el-container>
</template>

<style>
    :root{
        --el-menu-item-height:46px !important;
    }

    .appBody{
        box-shadow: 3px 3px 5px #f4f1f1 inset;
    }

    .main-body{
        box-shadow: -5px -5px 5px #f4f1f1;
        background-color:rgb(255, 255, 255);
        width:100%;
        height: 100%;
        padding: 20px;
    }

    .adminLayout{
        height: 100%;
    }

    .adminLayoutHeader {
        padding-left: 0px !important;
        border:1px solid #eee;
        line-height:var(--el-header-height);
    }
    

    .adminLayoutMain{
        --el-header-height:60px;
        height: calc(100% - var(--el-header-height));
    }


    /* menu css */
    .ExpandContainer>.adminLayoutMainLeft-Menu{
        width: 260px;
    }

    .adminLayoutMainLeft-Menu{
        border-right:solid 1px #e6e6e6;
        overflow: auto;
        box-sizing: border-box;
        flex-shrink: 0;
    }

    .adminLayout-menu-body{
        height: calc(100% - var(--el-menu-item-height));
    }

    .adminLayout-menu-foot{
        height: var(--el-menu-item-height);
    }

    .menu-foot-flod{
        margin-left: auto;
    }
    
    .adminLayout-menu-foot-item{
        border-top: 1px solid rgba(140,130,115,.13);;
        display: flex;
        align-items: center;
        height: var(--el-menu-item-height);
        line-height: var(--el-menu-item-height);
        font-size: var(--el-menu-item-font-size);
        
        padding: 0 var(--el-menu-base-level-padding);
        list-style: none;
        cursor: pointer;
        position: relative;
        transition: border-color var(--el-transition-duration),background-color var(--el-transition-duration),color var(--el-transition-duration);
        box-sizing: border-box;
    }
    
    .adminLayout-menu-foot-item [class^=el-icon] {
        margin-right: 5px;
        width: var(--el-menu-icon-width);
        text-align: center;
        font-size: 18px;
        vertical-align: middle;
    }


</style>

<script>
    import appHeader from "../components/TheAppHeader.vue"
    import menu from "../components/Menu/Menu.vue";
    import { Expand, Fold } from '@element-plus/icons-vue'

    export default {
        data: function () {
            return {
                siteName: ""
            }
        },

        computed:{
            menuExpandState:function(){
                return !this.$store.state.menuExpandState;
            },
            containerClass:function(){
                return this.$store.state.menuExpandState ? "ExpandContainer" : "";
            },
            visibleState:function(){
                return this.$store.state.notificationModal;
            }
        },
        
        components: {
            'expand':Expand,
            'fold':Fold,
            'Menu': menu,
            'AppHeader': appHeader
        },

        methods:{
            toggleMenuExpandState:function(){
                this.$store.commit("ToggleMenuState");
            }
        }
    }
</script>